import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "alert-text" }
const _hoisted_2 = ["aria-label"]

import { computed } from 'vue';
import WCToast from '@/modules/toasts/components/WCToast/WCToast.vue';
import WCToastHeader from '@/modules/toasts/components/WCToastHeader/WCToastHeader.vue';

interface Props {
  variant: 'warning' | 'danger' | 'success' | 'info';
  message: string;
  fullWidth?: boolean;
  dismiss?: () => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCToastModern',
  props: {
    variant: {},
    message: {},
    fullWidth: { type: Boolean, default: false },
    dismiss: { type: Function, default: () => {} }
  },
  setup(__props: any) {

const props = __props;

const variantIcon = computed(() => {
  const map: Record<string, string[]> = {
    warning: ['fas', 'triangle-exclamation'],
    danger: ['fas', 'circle-exclamation'],
    success: ['fas', 'circle-check'],
    info: ['fas', 'circle-info'],
  };
  return map[props.variant] ?? map.warning;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(WCToast, {
    class: _normalizeClass(["wc-toast-modern", [`wc-toast-modern--${_ctx.variant}`, { 'wc-toast-modern--full-width': _ctx.fullWidth }]]),
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, {
    default: _withCtx(() => [
      _createVNode(WCToastHeader, null, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: variantIcon.value,
            class: "alert-icon",
            "aria-hidden": "true"
          }, null, 8, ["icon"]),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("strong", _hoisted_1, _toDisplayString(_ctx.message), 1),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("button", {
            type: "button",
            class: "alert-close",
            "aria-label": _ctx.$t('close'),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'xmark'],
              "aria-hidden": "true"
            })
          ], 8, _hoisted_2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})